import dayjs from 'dayjs'

type Edge = 'from' | 'to'
type Range = { from?: string | null; to?: string | null }

// O backend recusa to < from (reportQueryValidator). Quando o campo que o usuário acabou de
// mexer deixa o intervalo invertido, empurra o OUTRO campo: trocar os dois viraria um
// intervalo de 1 minuto quando o Até ainda está no fim do dia anterior ao novo De.
export const normalizeDateRange = (range: Range, changed: Edge): Range => {
  const from = dayjs(range.from)
  const to = dayjs(range.to)
  if (!range.from || !range.to || !from.isValid() || !to.isValid() || !from.isAfter(to)) return range
  return changed === 'from'
    ? { from: range.from, to: from.endOf('day').toISOString() }
    : { from: to.startOf('day').toISOString(), to: range.to }
}

// Reaplica o período padrão da tela quando from/to somem do filtro (ex.: "Remover todos os
// filtros" faz setFilters({})). Devolve a MESMA referência se não há o que reaplicar.
export const withPeriodDefaults = <T extends Record<string, any>>(filterValues: T, defaults?: Record<string, any>): T => {
  const missing = (['from', 'to'] as const).filter(key => defaults?.[key] && !filterValues[key])
  if (!missing.length) return filterValues
  const next: Record<string, any> = { ...filterValues }
  missing.forEach(key => { next[key] = defaults![key] })
  return next as T
}
